import { render, staticRenderFns } from "./EventBannerForm.vue?vue&type=template&id=3164b024&scoped=true&"
import script from "./EventBannerForm.vue?vue&type=script&lang=js&"
export * from "./EventBannerForm.vue?vue&type=script&lang=js&"
import style0 from "./EventBannerForm.vue?vue&type=style&index=0&id=3164b024&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3164b024",
  null
  
)

export default component.exports